import React from 'react';
import util from "../../util/tools";
import './index.css';

export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            statu: "1",//1:第一步 2:第二步
            curProid: "",
            data: []
        };
        this.nextFun = this.nextFun.bind(this);
        this.subFun = this.subFun.bind(this);
        this.backFun = this.backFun.bind(this);
        this.jumpFun = this.jumpFun.bind(this);
        this.tsxzFun = this.tsxzFun.bind(this);
    }

    componentDidMount() {
        document.title = '投诉';
        this.wechatInfo()
    }

    wechatInfo(){
        util.ajax({
            url: "/zh/complaint/problemlists",
            data: {},
            callback: res => {
                if (res.result.status.code == 0) {
                    let data = res.result.data
                    this.setState({
                        data
                    })
                }
            }
        });
    }

    nextFun(id){
        this.setState({
            curProid: id,
            statu: "2"
        });
    }
    tsxzFun(){
        this.setState({
            statu: "4"
        });
    }

    subFun(){
        util.ajax({
            url: "/zh/complaint/edit",
            isUser: true,
            isWechatId: true,
            method: "post",
            data: {
                ip: "num",
                book_id:this.props.match.params.bookId,
                content_id: this.props.match.params.contentId,
                problem_id: this.state.curProid
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    this.setState({
                        statu: "3"
                    });
                }
            }
        });
    }

    backFun(){
        try{
            window.history.back();
        }catch(e){}
    }

    jumpFun(url){
        if(!!url){
            document.location.href = url;
        }
    }

    render() {
        return <div>暂不显示</div>
        // return (
        //     <div className={`tsPage ${this.state.statu==4?"step4Page":""}`}>
        //         {/* 第一步 */}
        //         <div className={`step1 ${this.state.statu==1?"":"nodis"}`}>
        //             <div className='title1'>请选择投诉该网页的原因:</div>
        //             <div className="clearfix list">
        //                 {
        //                     this.state.data.map((item,index)=>(
        //                         <div className="item" key={`k_${index}`} onClick={()=>this.nextFun(item.problem_id)} data-id={item.problem_id}>{item.content}</div>
        //                     ))
        //                 }
        //             </div>
        //             <div className='title2' onClick={()=>this.jumpFun("https://mp.weixin.qq.com/s/TbX1CcZhQNReneXVc3At9Q?client=tim&ADUIN=754901027&ADSESSION=1559010629&ADTAG=CLIENT.QQ.5603_.0&ADPUBNO=26882")}>遇到网页流量被劫持怎么办</div>
        //         </div>
        //         {/* 第二步 */}
        //         <div className={`step2 ${this.state.statu==2?"":"nodis"}`}>
        //             <div className='title1'>你可以:</div>
        //             <div className="clearfix list">
        //                 <div className="item" onClick={this.subFun}>提交给微信团队审核</div>
        //             </div>
        //         </div>
        //         {/* 第三步 */}
        //         <div className={`step3 ${this.state.statu==3?"":"nodis"}`}>
        //             <img  src={require(`../../../common/images/tsBg2.png`)} />
        //             <div className="closeBtn" onClick={this.backFun}></div>
        //         </div>
        //         {/* 第四步 */}
        //         <div className={`step4 ${this.state.statu==4?"":"nodis"}`}>
        //             <div className="title">投诉须知</div>
        //             <div className="tip">你应保证你的投诉行为基于善意，并代表你本人真实意思。腾讯作为中立的平台服务者，收到你投诉后，会尽快按照相关法律法规的规定独立判断并进行处理。腾讯将会采取合理的措施保护你的个人信息；除法律法规规定的情形外，未经用户许可腾讯不会向第三方公开、透露你的个人信息。</div>
        //         </div>
        //         {
        //             this.state.statu != 3 && this.state.statu != 4 &&
        //             <div className='title3' onClick={this.tsxzFun}>投诉须知</div>
        //         }
        //     </div>
        // );
    }
}